import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { useState } from 'react';
import { nanoid } from 'nanoid';

export const ShipmentContentsModal = ({ show, handleClose, shipmentContents, setShipmentContents, revertShipmentContents }) => {
    const [formData, setFormData] = useState({
        code: '',
        partNum: '',
        itemNum: '',
        quantity: 1,
        description: ''
    });
    const [selectedContentIds, setSelectedContentIds] = useState([]);

    const clearForm = () => {
        setFormData({
            code: '',
            partNum: '',
            itemNum: '',
            quantity: 1,
            description: ''
        });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const addContent = () => {
        // TODO - form field validation?
        const obj = { ...formData, id: nanoid() };
        setShipmentContents([...shipmentContents, obj]);
        clearForm();
    }

    const removeContent = () => {
        setShipmentContents(shipmentContents.filter((i) => !selectedContentIds.includes(i.id)));
        setSelectedContentIds([]);
        clearForm();
    }

    const updateContent = () => {
        const id = selectedContentIds[0];
        setShipmentContents(shipmentContents.map((item) => (
            item.id === id ? { ...formData, id } : item
        )));
        clearForm();
        setSelectedContentIds([]);
    }

    const handleCheckChange = (e) => {
        const { value, checked } = e.target;
        if (selectedContentIds.length === 0) {
            setFormData(shipmentContents.find((i) => i.id === value));
        } else {
            clearForm();
        }
        if (checked) {
            setSelectedContentIds([...selectedContentIds, value])
        } else {
            setSelectedContentIds(selectedContentIds.filter((i) => i !== value));
        }
    }

    const closeWithoutSaving = () => {
        revertShipmentContents();
        handleClose();
    }

    return (
        <Modal show={show} onHide={closeWithoutSaving} backdrop='static'>
            <Modal.Header closeButton>Shipping Content(s)</Modal.Header>
            <Modal.Body>
                <Form.Group className='form-group'>
                    <Form.Label>Code</Form.Label>
                    <Form.Select
                        name='code'
                        value={formData.code}
                        onChange={handleChange}
                    >
                        <option value=''>Select an option</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className='form-group'>
                    <Form.Label>Part number</Form.Label>
                    <Form.Control
                        name='partNum'
                        value={formData.partNum}
                        onChange={handleChange}
                    />
                </Form.Group>
                <Form.Group className='form-group'>
                    <Form.Label>SKU/Item/UPC</Form.Label>
                    <Form.Control
                        name='itemNum'
                        value={formData.itemNum}
                        onChange={handleChange}
                    />
                </Form.Group>
                <Form.Group className='form-group'>
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        name='quantity'
                        value={formData.quantity}
                        onChange={handleChange}
                    />
                </Form.Group>
                <Form.Group className='form-group'>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        name='description'
                        value={formData.description}
                        onChange={handleChange}
                        as='textarea'
                    />
                </Form.Group>
                <Button onClick={addContent} variant='secondary'>Add to shipment</Button>
                <br />
                <br />
                <fieldset>
                    <legend>Shipping Content(s)</legend>
                    <Table>
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Part number</th>
                                <th>SKU/Item/UPC</th>
                                <th>Quantity</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                shipmentContents.map((i) => (
                                    <tr key={i.id}>
                                        <td>
                                            <Form.Check
                                                type='checkbox'
                                                value={i.id}
                                                checked={selectedContentIds.includes(i.id)}
                                                onChange={handleCheckChange}
                                            />
                                        </td>
                                        <td>{i.partNum}</td>
                                        <td>{i.itemNum}</td>
                                        <td>{i.quantity}</td>
                                        <td>{i.description}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                    <br />
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <Button onClick={removeContent} disabled={!selectedContentIds.length > 0} variant='secondary'>Delete</Button>
                        <Button onClick={updateContent} disabled={selectedContentIds.length > 1 || selectedContentIds.length < 1} variant='secondary'>Update</Button>
                        <Button onClick={() => setShipmentContents([])} variant='secondary'>Clear all</Button>
                    </div>
                </fieldset>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} className='purple-btn'>Ok</Button>
                <Button onClick={closeWithoutSaving} variant='secondary'>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}